export default __webpack_public_path__ + "static/chair-sm-f0d852d0851cd189d3d0d074ed09ef9a.png";